export const actionTypes = {
  SET_DATA: 'TAXES.PAYMENT.SET_DATA',
  EDIT: 'TAXES.PAYMENT.EDIT_MODE.EDIT',
  REVERT: 'TAXES.PAYMENT.EDIT_MODE.REVERT',
  SET_DISABLED: 'TAXES.PAYMENT.EDIT_MODE.SET_DISABLED',
};

export function setData(data) {
  return {
    type: actionTypes.SET_DATA,
    payload: data,
  };
}

export function edit(path, value) {
  return {
    type: actionTypes.EDIT,
    payload: { path, value },
  };
}

export function revert(path) {
  return {
    type: actionTypes.REVERT,
    payload: path,
  };
}

export function setDisabled(path, value) {
  return {
    type: actionTypes.SET_DISABLED,
    payload: { path, value },
  };
}
